module.exports = __webpack_public_path__ + "static/media/generic.5f586632.svg";